var map = {
	"./image-cards.de-CH.json": 1414,
	"./image-cards.de-DE.json": 1415,
	"./image-cards.en-CA.json": 1416,
	"./image-cards.en-GB.json": 1417,
	"./image-cards.en-IN.json": 1418,
	"./image-cards.en-ME.json": 1419,
	"./image-cards.en-US.json": 1420,
	"./image-cards.es-EM.json": 1421,
	"./image-cards.es-ES.json": 1422,
	"./image-cards.fr-BE.json": 1423,
	"./image-cards.fr-CA.json": 1424,
	"./image-cards.fr-CH.json": 1425,
	"./image-cards.nl-BE.json": 1426,
	"./image-cards.nl-NL.json": 1427,
	"./image-cards.pl-PL.json": 1428,
	"./image-cards.pt-BR.json": 1429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1413;